module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isHidden) ? _c('div', [_vm._m(0, false, false)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voters-outer"
  }, [_c('div', {
    staticClass: "voters-wrapper"
  }, [_c('div', {
    staticClass: "voters-inner clearfix"
  }, [_c('div', {
    staticClass: "voters-container"
  }, [_c('div', {
    staticClass: "voters-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "voters-middle"
  }, [_c('a', {
    attrs: {
      "href": "http://www.foxsearchlight.com/awards/the-shape-of-water/",
      "target": "_blank"
    }
  }, [_vm._v("FIND A SCREENING")])]), _vm._v(" "), _c('img', {
    staticClass: "voters-bottom",
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/fancy-frame.png",
      "alt": "fancy-frame"
    }
  })])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a5ebf45", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a5ebf45","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Voters.vue
// module id = 402
// module chunks = 0